export default __webpack_public_path__ + "static/media/nfo-card-banner-special-opportunities-fund.62e57118.webp";